import Loadable from 'Components/LoadableToImported'

// const loading = () => <Spinner />

export default Loadable({
  loader: () => import(/* webpackChunkName: "AppSwiper" */ './AppSwiper'),
  // loading,
  chunkName: 'AppSwiper',
})
